import { render } from "./CurrentPlan.vue?vue&type=template&id=4cc97502&scoped=true"
import script from "./CurrentPlan.vue?vue&type=script&lang=js"
export * from "./CurrentPlan.vue?vue&type=script&lang=js"

import "./CurrentPlan.vue?vue&type=style&index=0&id=4cc97502&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-4cc97502"

export default script